import { AssignmentNameComponent } from '@agent/features/assignment/assignment-name/assignment-name.component';
import { AssignmentStatusStickerComponent } from '@agent/components/status-stickers/assignment-status-sticker.component';
import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { type AssignmentDTO } from '@api/models';
import { TranslatePipe } from '@ngx-translate/core';
import { PermissionDirective } from '@common/directives/permission.directive';
import { AssignmentFilterPipe } from '@shared/pipes/assignments-filter.pipe';
import { CompanyDatePipe } from '@common/pipes/company-date.pipe';
import { OrderByPipe } from '@common/pipes/order-by.pipe';
import { ResourcePipe } from '@shared/pipes/resource.pipe';
import { CardEmptyComponent } from '@common/ui/card/card-empty.component';
import { AuthService } from '@infra/auth/auth.service';
import { Globals } from '@system/globals';
import { AssignmentNumberComponent } from '@agent/features/assignment/assignment-number/assignment-number.component';

@Component({
  selector: 'app-assignment-list',
  templateUrl: './assignment-list.component.html',
  imports: [
    AssignmentFilterPipe,
    AssignmentStatusStickerComponent,
    PermissionDirective,
    OrderByPipe,
    CompanyDatePipe,
    TranslatePipe,
    AssignmentNameComponent,
    CardEmptyComponent,
    ResourcePipe,
    AsyncPipe,
    AssignmentNumberComponent,
  ],
  host: {
    style: 'display: contents',
  },
})
export class AssignmentListComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  @Input() assignments: AssignmentDTO[];
  @Input() customerId: string;
  @Input() bookingAgentId: string;
  @Input() accountId: string;
  @Input() title: string;
  @Input() showCreateButton: boolean;
  @Input() closed: boolean;
  @Input() activeOnly = false;

  @Output() assignmentClosedEvent = new EventEmitter<string>();

  globals = Globals;
  display = 'none';

  constructor() {
    this.assignments = [];
    this.showCreateButton = true;
    this.closed = false;
  }

  addAssignment(): void {
    if (this.authService.hasMultipleCreateFlow) {
      if (this.customerId != null) {
        this.router.navigate([`/${this.authService.companyUrl}/create/choose/customer/${this.customerId}`]);
      } else if (this.bookingAgentId != null) {
        this.router.navigate([`/${this.authService.companyUrl}/create/choose/agent/${this.bookingAgentId}`]);
      } else if (this.accountId != null) {
        this.router.navigate([`/${this.authService.companyUrl}/create/choose/account/${this.accountId}`]);
      }
    } else {
      if (this.customerId != null) {
        this.router.navigate([`/${this.authService.companyUrl}/create/move/customer/${this.customerId}`]);
      } else if (this.bookingAgentId != null) {
        this.router.navigate([`/${this.authService.companyUrl}/create/move/agent/${this.bookingAgentId}`]);
      } else if (this.accountId != null) {
        this.router.navigate([`/${this.authService.companyUrl}/create/move/account/${this.accountId}`]);
      }
    }
  }

  viewAssignment(assignment: AssignmentDTO): void {
    this.router.navigate([`/${this.authService.companyUrl}/assignment/${assignment.id}`]);
  }
}
